import React, { useState } from 'react';
import './Allorders.scss';
import { FaCheck } from "react-icons/fa";


export default function Cancelledorders() {
  const [activeRow, setActiveRow] = useState(null);
  const [open, setOpen] = useState(null);

  const [orders] = useState([
    {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
    {
      id: '#301556',
      client: 'Osama alabyaare',
      product: 'E-book',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'New',
    },
    {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Rejected',
    },
        {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
        {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
        {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
        {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
        {
      id: '#301555',
      client: 'Osama alabyaare',
      product: 'Social media',
      date: '12/12/23',
      time: '12:00 PM',
      amount: 'EGP 241.00',
      status: 'Cancelled',
    },
  ]);

  const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };

  return (
    <div className="orders-container p-3">

<div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>


      <div className="orders-table-wrapper">
        <table className="orders-table">
          <thead>
            <tr>
              <th><input type="checkbox" /></th>
              <th>Order ID</th>
              <th>Client Name</th>
              <th>Product</th>
              <th>Date</th>
              <th>Order time</th>
              <th>Amount</th>
                 <th className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                  Status
                  <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {open === "Status" && (
                    <div className="list-body">
                      <ul className="list">
                        <li>All Status</li>
                        <li>New</li>
                        <li>On Process</li>
                        <li>Late Order</li>
                      </ul>
                    </div>
                  )}
                </th>
              <th>Order Details</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td><input type="checkbox" /></td>
                  <td className="order-id">{order.id}</td>
                  <td>{order.client}</td>
                  <td>{order.product}</td>
                  <td>{order.date}</td>
                  <td>{order.time}</td>
                  <td>{order.amount}</td>
                  <td>
  <span className={`status ${order.status.replace(/\s+/g, '')}`}>
    {order.status}
  </span>
</td>
                  <td>
                    <span
                      className="order-details"
                      onClick={() => toggleDetails(index)}
                    >
                      ...
                    </span>
                  </td>
                </tr>

             {activeRow === index && (
  <>

    <tr className="details-row headers-row">
      <td colSpan="9">
        <div className="order-details-box header">
          <div className="section "
           style={{
            color:"#999999"
          }}>Full Name</div>
          <div className="section"   style={{
            color:"#999999"
          }}>PHONE</div>


          <div className="section"   style={{
            color:"#999999"
          }}>EMAIL
          </div>
          <div className="section"   style={{
            color:"#999999"
          }}>COUNTRY</div>

          <div className="section"   style={{
            color:"#999999"
          }}>DATE</div>

          <div className="section"   style={{
            color:"#999999"
          }}>Time</div>

          <div className="section"  style={{
            color:"#999999"
          }}>Print</div>
        </div>
      </td>
    </tr>

    
    <tr className="details-row values-row">
      <td colSpan="9">
        <div className="order-details-box values">
          <h3 className="section">Osama Ali alabyaare</h3>
          <h3 className="section">+20 1012345678</h3>
          <h3 className="section">osama@email.com</h3>
          <h3 className="section">Egypt</h3>
          <h3 className="section">12/12/23</h3>
          <h3 className="section">12:00 PM</h3>
          <div   className="product-header"
 onClick={() => setOpen(open === "Confirm" ? null : "Confirm")}>

  Confirm
  <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
     {open === "Confirm" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Products</li>
                            <li>Social media</li>
                            <li>E-marketing</li>
                          </ul>
                        </div>
                      )}


          </div>
        </div>
      </td>
    </tr>
  <>


{/* ////////////////////// */}
    <tr className="details-row headers-row">
      <td colSpan="9">
        <div className="order-details-box header">
          <div className="section"    style={{
            color:"#999999"
          }}>ORDER TYPE</div>
          <div className="section"    style={{
            color:"#999999"
          }}>CATEGORY</div>
          <div className="section"    style={{
            color:"#999999"
          }}>SKU</div>
          <div className="section"    style={{
            color:"#999999"
          }}>DURATION</div>
          <div className="section"    style={{
            color:"#999999"
          }}>START</div>
          <div className="section"    style={{
            color:"#999999"
          }}>ENDS</div>
          <div className="section"    style={{
            color:"#999999"
          }}>DAYS</div>
      
        </div>
      </td>
    </tr>

    
    <tr className="details-row values-row">
      <td colSpan="9">
        <div className="order-details-box values">
          <h3 className="section">Service</h3>
          <h3 className="section">Social media</h3>
          <h3 className="section">#6580</h3>
          <h3 className="section">1 month</h3>
          <h3 className="section">24 may 2025</h3>
          <h3 className="section">24 may 2025</h3>
          <h3 className="section">30</h3>
 
        </div>
      </td>
    </tr>
{/* //////////////////////////////////// */}

  <>

    <tr className="details-row headers-row">
      <td colSpan="9">
        <div className="order-details-box header">
          <div className="section"    style={{
            color:"#999999"
          }}>PRICE</div>
          <div className="section"   style={{
            color:"#999999"
          }}>TOTAL AMOUNT</div>
          <div className="section"    style={{
            color:"#999999"
          }}>PAYMENT METHOD</div>
          <div className="section"    style={{
            color:"#999999"
          }}>BANK NAME</div>
          <div className="section"    style={{
            color:"#999999"
          }}>ACCOUNT NO</div>
          <div className="section"    style={{
            color:"#999999"
          }}>DUE DATE</div>
          <div className="section"    style={{
            color:"#999999"
          }}>PAYMENT STATUS</div>
        </div>
      </td>
    </tr>

    
    <tr className="details-row values-row">
      <td colSpan="9">
        <div className="order-details-box values">
          <h3 className="section">EGP200</h3>
          <h3 className="section">EGP200</h3>
          <h3 className="section">credit card</h3>
          <h3 className="section">+insta</h3>
          <h3 className="section">********65</h3>
          <h3 className="section">24 may 2025</h3>
<div className="succ">
  <span className="icon-circle">
    <FaCheck className="icon" />
  </span>
  Successful
</div>


        </div>
      </td>
    </tr>

    
  </>
    
  </>
    
  </>
  
)}

              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
